import { css, html, LitElement } from 'lit';
import { Text } from '../Text/Text';
import { Button } from '../Buttons/Buttons';
import { Icon } from '../Icon/Icon';

class SharePopup extends LitElement {
  static properties = {
    title: { type: String },
    shareLink: { type: String },
    primaryActionText: { type: String },
    secondaryActionText: { type: String },
    color: { type: String },
    svgSize: { type: String },
    height: { type: String },
    width: { type: String },
    borderRadius: { type: String },
    popupBgColor: { type: String },
    titleColor: { type: String },
    ctaColor: { type: String },
    dialogData: { type: Object}
  };

  constructor() {
    super();
    this.svgSize = '40px';
    this.closeButtonBorderRadius = '50%';
    this.closeButtonBgColor = '#f2f3fc';
    this.closeButtonTextColor = '#000';
    this.popupBgColor = '#fff';
    this.primaryActionText = 'Copy';
  }

  render() {
    return html`
      <div class="popup" style="background-color: ${this.popupBgColor}; height: ${this.height}; width: ${this.width}; border-radius: ${this.borderRadius};">
        <div class="header">
          ${Text({
            content: this.dialogData.title,
            fontSize: '18px',
            fontWeight: 'bold',
            color: this.dialogData.titleColor,
            textAlign: 'center',
          })}
        </div>

        <div class="social-links">
          <div class="social-buttons">
            <button class="social-button" @click=${() => this._openSocial('facebook')}>${Icon('facebook', this.svgSize)}</button>
            <button class="social-button" @click=${() => this._openSocial('whatsapp')}>${Icon('whatsapp', this.svgSize)}</button>
            <button class="social-button" @click=${() => this._openSocial('email')}>${Icon('email', this.svgSize)}</button>
          </div>
        </div>
        <div class="copy-link-section">
          <input type="text" value=${this.dialogData.shareLink} readonly class="link-input" />
          ${Button({
            label: this.primaryActionText,
            fontSize: '14px',
            fontWeight: 'bold',
            color: this.dialogData.ctaColor,
            textAlign: 'center',
            onClick: this._copyLink,
            backgroundColor: 'var(--text-primary-color)',
            textColor: 'var(--bg-primary-color)',
            borderWidth: '0px',
          })}
        </div>
      </div>
    `;
  }

  _copyLink() {
    navigator.clipboard.writeText(this.dialogData.shareLink).then(() => {
      const button = this.shadowRoot.querySelector('.copy-link-section button');
      button.textContent = 'Copied!';
      setTimeout(() => {
        button.textContent = this.primaryActionText;
      }, 2000);
    });
  }

  _openSocial(platform) {
    const encodedLink = encodeURIComponent(this.dialogData.shareLink);

    let url = '';
    if (platform === 'facebook') {
      url = `https://www.facebook.com/sharer/sharer.php?u=${encodedLink}`;
    } else if (platform === 'whatsapp') {
      url = `https://wa.me/?text=${encodedLink}`;
    } else if (platform === 'email') {
      url = `mailto:?subject=Check this out&body=${encodedLink}`;
    }

    window.open(url, '_blank');
  }

  static styles = css`
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 18px;
      font-weight: bold;
      border-bottom: 1px solid #ccc;
      padding-bottom: 8px;
    }
    .social-links {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin: 16px 0;
      align-items: flex-start;
    }
    .social-buttons {
      display: flex;
      flex-direction: row;
      gap: 10px;
    }
    .social-button {
      border: none;
      background: none;
      cursor: pointer;
    }
    .copy-link-section {
      display: flex;
      align-items: center;
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 3px;
    }
    .copy-link-section button:hover {
      border: none;
      padding: 8px 16px;
      border-radius: 4px;
    }
    .link-input {
      flex: 1;
      margin-right: 8px;
      padding: 8px;
      border: none;
      border-radius: 4px;
      font-size: 14px;
    }
    button {
      border: none;
      padding: 8px 16px;
      border-radius: 4px;
      cursor: pointer;
    }
  `;
}

customElements.define('share-popup', SharePopup);
